import { Box, Flex, Text } from "@chakra-ui/react"
import { getSharedStatusPillStyle, getStatusColor } from "common/utils/statusColor";

const CustomStatus = (props) => {
    const { statusText, color } = props
    const normalizedStatus = getSharedStatusPillStyle(statusText)
    const sanitizedColor = String(color || getStatusColor(statusText)).replace(/\s*!important\s*/gi, "").trim()
    const resolvedColor = color ? sanitizedColor : (normalizedStatus.isMapped ? normalizedStatus.color : sanitizedColor)
    const resolvedLabel = normalizedStatus.isMapped ? normalizedStatus.label : statusText

    return (
        <>
            <Flex
                className="todoStatusWrap"
                alignItems={'center'}
                gap={'8px'}
                whiteSpace="nowrap"
                color={resolvedColor}
                style={{ color: resolvedColor, "--todo-status-color": resolvedColor }}
                sx={{ color: `${resolvedColor} !important` }}
                _hover={{ color: resolvedColor }}
            >
                {resolvedLabel && <Box className="todoStatusIndicator" borderRadius={'50%'} h={'6px'} w={'6px'} backgroundColor={resolvedColor}></Box>}
                <Text
                    className="todoStatusText"
                    color={resolvedColor}
                    fontWeight="500"
                    style={{ color: resolvedColor }}
                    sx={{ color: `${resolvedColor} !important` }}
                    _hover={{ color: resolvedColor }}
                >
                    {resolvedLabel && resolvedLabel}
                </Text>
            </Flex>
        </>
    )
}

export default CustomStatus
